module.exports = __webpack_public_path__ + "fonts/Montserrat-Italic.2e796859.ttf";